/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import { useState, useEffect, useRef } from 'react';
import { TbTargetArrow } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import { HiOutlineRocketLaunch } from "react-icons/hi2";
// import { RiWhatsappFill } from "react-icons/ri";
// import { MdBadge } from "react-icons/md";
import { FaVideo } from "react-icons/fa";
import { MdOutlineAssuredWorkload } from "react-icons/md";
import { Img } from 'components';
import { PREFIX } from 'utils';

const Icon1 = TbTargetArrow as React.FC<any>;
const Icon2 = BiSupport as React.FC<any>;
const Icon3 = FaChalkboardTeacher as React.FC<any>;
const Icon4 = FiSettings as React.FC<any>;
const Icon5 = HiOutlineRocketLaunch as React.FC<any>;
// const Icon6 = RiWhatsappFill as React.FC<any>;
// const Icon7 = MdBadge as React.FC<any>;
const Icon8 = FaVideo as React.FC<any>;
const Icon9 = MdOutlineAssuredWorkload as React.FC<any>;

// Main carousel - 5 items
const teamMembers = [
  {
    des: "5 Marketing Agents",
    role: "AI Marketing",
    image: "images/new-landing-page/marketingThumbV2.png",
    bg: "bg-[#9F8AF1]",
    videoUrl: "videos/digitalMarketingAgentNew.mp4",
    icon: <Icon1 />,
    prefix: PREFIX.D_MARKETING_PREFIX,
    glowColor: "#9F8AF1"
  },
  {
    des: "4 AI Support Agents",
    role: "AI Support",
    image: "images/new-landing-page/supportThumbV2.png",
    bg: "bg-[#FF8069]",
    videoUrl: "videos/selfHealingSupportNew.mp4",
    icon: <Icon2 />,
    prefix: PREFIX.SUPPORT_PREFIX,
    glowColor: "#FF8069"
  },
  {
    des: "4 AI Teachers",
    role: "Teaching",
    image: "images/new-landing-page/teacherThumbV2.png",
    bg: "bg-[#488EFB]",
    videoUrl: "videos/teacherAgentNew.mp4",
    icon: <Icon3 />,
    prefix: PREFIX.TEACHER_PREFIX,
    glowColor: "#488EFB"
  },
  // {
  //   des: "3 Startups Assistant",
  //   role: "Startups",
  //   image: "images/new-landing-page/startupThumbV2.png",
  //   bg: "bg-[#FFB700]",
  //   videoUrl: "videos/forSchoolStartupsNew.mp4",
  //   icon: <Icon5 />,
  //   prefix: STARTUP_PREFIX,
  //   glowColor: "#FFB700"
  // },
  {
    des: "Admission Assured",
    role: "100% Admission",
    image: "images/new-landing-page/admissionThumbV2.png",
    bg: "bg-[#FFB700]",
    videoUrl: "",
    icon: <Icon5 />,
    prefix: PREFIX.ADMISSION_ASSURED_PREFIX,
    glowColor: "#FFB700"
  },
  {
    des: "4 Admin Staff",
    role: "Operations",
    image: "images/new-landing-page/operatorThumbV2.png",
    bg: "bg-[#00c3b2]",
    videoUrl: "videos/operationAgentNew.mp4",
    icon: <Icon4 />,
    prefix: PREFIX.OPERATOR_PREFIX,
    glowColor: "#00c3b2"
  }
];

// Sticky header - 5 items (removed Webinar)
export const stickyHeaderItems = [
  {
    des: "5 Marketing Agents",
    role: "AI Marketing",
    image: "images/new-landing-page/hero1.png",
    bg: "bg-[#9F8AF1]",
    videoUrl: "videos/digitalMarketingAgentNew.mp4",
    icon: <Icon1 />,
    prefix: PREFIX.D_MARKETING_PREFIX,
    glowColor: "#9F8AF1"
  },
  {
    des: "4 AI Teachers",
    role: "Teaching",
    image: "images/new-landing-page/hero3.png",
    bg: "bg-[#488EFB]",
    videoUrl: "videos/teacherAgentNew.mp4",
    icon: <Icon3 />,
    prefix: PREFIX.TEACHER_PREFIX,
    glowColor: "#488EFB"
  },
  {
    des: "4 AI Support Agents",
    role: "AI Support",
    image: "images/new-landing-page/hero4.png",
    bg: "bg-[#FF8069]",
    videoUrl: "videos/selfHealingSupportNew.mp4",
    icon: <Icon2 />,
    prefix: PREFIX.SUPPORT_PREFIX,
    glowColor: "#FF8069"
  },
  {
    des: "Admission Assured",
    role: "100% Admission",
    image: "images/new-landing-page/hero5.png",
    bg: "bg-[#FFB700]",
    videoUrl: "videos/forSchoolStartupsNew.mp4",
    icon: <Icon9 />,
    prefix: PREFIX.ADMISSION_ASSURED_PREFIX,
    glowColor: "#FFB700",
  },
  {
    des: "4 Admin Staff",
    role: "Operations",
    image: "images/new-landing-page/hero2.png",
    bg: "bg-[#00c3b2]",
    videoUrl: "videos/operationAgentNew.mp4",
    icon: <Icon4 />,
    prefix: PREFIX.OPERATOR_PREFIX,
    glowColor: "#00c3b2"
  },
  // {
  //   des: "3 Startups Assistant",
  //   role: "Startups",
  //   image: "images/new-landing-page/hero5.png",
  //   bg: "bg-[#FFB700]",
  //   videoUrl: "videos/forSchoolStartupsNew.mp4",
  //   icon: <Icon5 />,
  //   prefix: STARTUP_PREFIX,
  //   glowColor: "#FFB700"
  // }
];

// Separate Webinar card data
const webinarCard = {
  des: "Live Webinars",
  role: "Webinar",
  image: "images/new-landing-page/hero1.png",
  bg: "bg-[#EF4444]",
  videoUrl: "videos/webinar.mp4",
  icon: <Icon8 />,
  prefix: PREFIX.WEBINAR_PREFIX,
  glowColor: "#EF4444"
};

export interface CardsCarouselProps {
  renderComponents?: any[];
  sectionRefs?: React.MutableRefObject<any[]>;
  scrollUp?: () => void;
  usePrefix?: boolean;
}

const CardsCarousel: React.FC<CardsCarouselProps> = ({ renderComponents = [], sectionRefs, scrollUp }) => {
  // Add custom styles for animations
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0%, 100% {
          opacity: 1;
        }
        50% {
          opacity: 0.5;
        }
      }
      .animate-pulse {
        animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  // const [fadeInfo, setFadeInfo] = useState(true);
  const [touchStart, setTouchStart] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [userClickedNonMarketing, setUserClickedNonMarketing] = useState(false);
  const [playedVideos, setPlayedVideos] = useState(new Set());
  // const [allVideosPlayed, setAllVideosPlayed] = useState(false);
  const [animationEnabled, setAnimationEnabled] = useState(false);
  const [userInteracted, setUserInteracted] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [stickyCurrentIndex, setStickyCurrentIndex] = useState(0);
  const [videoLoading, setVideoLoading] = useState<Set<number>>(new Set(teamMembers.map((_, i) => i)));

  const videoRefs: any = useRef([]);
  const infoSectionRef = useRef(null);
  const carouselRef = useRef(null);

  const isWebinar = (stickyCurrentIndex === -1);

  // Helper function to get team member index from section ID for sticky header
  const getStickyTeamMemberIndexFromId = (sectionId: string) => {
    if (!sectionId) return 0;

    // Check if it's a webinar section - return -1 to indicate webinar card should be highlighted
    if (sectionId.startsWith(PREFIX.WEBINAR_PREFIX)) {
      return -1;
    }

    for (let i = 0; i < stickyHeaderItems.length; i++) {
      if (sectionId.startsWith(stickyHeaderItems[i].prefix)) {
        return i;
      }
    }
    return 0;
  };

  const getCardPosition = (index) => {
    const offset = (index - currentIndex + teamMembers.length) % teamMembers.length;

    if (offset === 0) return 'center';
    if (offset === 1) return 'right-1';
    if (offset === 2) return 'right-2';
    if (offset === teamMembers.length - 1) return 'left-1';
    if (offset === teamMembers.length - 2) return 'left-2';
    return 'hidden';
  };

  const getStickyCardPosition = (index) => {
    const offset = (index - stickyCurrentIndex + stickyHeaderItems.length) % stickyHeaderItems.length;

    if (offset === 0) return 'center';
    if (offset === 1) return 'right-1';
    if (offset === 2) return 'right-2';
    if (offset === stickyHeaderItems.length - 1) return 'left-1';
    if (offset === stickyHeaderItems.length - 2) return 'left-2';
    return 'hidden';
  };

  const getCardSection = (position, isSticky?) => {
    const baseStyle = {
      transition: 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    };
    switch (position) {
      case 'center':
        return {
          ...baseStyle,
          transform: 'translateX(0) scale(1)',
          zIndex: 10,
        };
      case 'left-1':
        return {
          ...baseStyle,
          transform: isSticky ? 'translateX(-30vh) scale(1)' : 'translateX(-28vh) scale(0.875)',
          zIndex: 5,
        };
      case 'left-2':
        return {
          ...baseStyle,
          transform: isSticky ? 'translateX(-58vh) scale(1)' : 'translateX(-52vh) scale(0.75)',
          zIndex: 1,
        };
      case 'right-1':
        return {
          ...baseStyle,
          transform: isSticky ? 'translateX(30vh) scale(1)' : 'translateX(28vh) scale(0.875)',
          zIndex: 5,
        };
      case 'right-2':
        return {
          ...baseStyle,
          transform: isSticky ? 'translateX(58vh) scale(1)' : 'translateX(52vh) scale(0.75)',
          zIndex: 1,
        };
      case 'hidden':
        return {
          ...baseStyle,
          opacity: 0,
          pointerEvents: 'none',
        };
      default:
        return baseStyle;
    }
  };

  const getCardStyles = (position) => {
    const baseStyle = {
      transition: 'all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      cursor: 'pointer',
    };

    switch (position) {
      case 'center':
        return {
          ...baseStyle,
          transform: 'scale(1.1) translateZ(0)',
          zIndex: 10,
        };
      case 'left-1':
        return {
          ...baseStyle,
          transform: 'translateX(-28vh) scale(0.9) translateZ(-100px)',
          zIndex: 5,
        };
      case 'left-2':
        return {
          ...baseStyle,
          transform: 'translateX(-52vh) scale(0.8) translateZ(-300px)',
          zIndex: 1,
        };
      case 'right-1':
        return {
          ...baseStyle,
          transform: 'translateX(28vh) scale(0.9) translateZ(-100px)',
          zIndex: 5,
        };
      case 'right-2':
        return {
          ...baseStyle,
          transform: 'translateX(52vh) scale(0.8) translateZ(-300px)',
          zIndex: 1,
        };
      case 'hidden':
        return {
          ...baseStyle,
          opacity: 0,
          pointerEvents: 'none',
          cursor: 'default',
        };
      default:
        return baseStyle;
    }
  };

  const updateCarousel = (newIndex) => {
    if (isAnimating) return;

    if (!userInteracted) {
      setAnimationEnabled(true);
    }
    setIsAnimating(true);
    // setFadeInfo(false);

    // Pause all videos before changing index
    videoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
      }
    });

    const normalizedIndex = (newIndex + teamMembers.length) % teamMembers.length;
    setCurrentIndex(normalizedIndex);

    // setTimeout(() => {
    //   setFadeInfo(true);
    // }, 300);

    setTimeout(() => {
      setIsAnimating(false);
    }, 800);
  };

  const handleVideoPlay = (index) => {
    // Not needed anymore, we track clicks instead
  };

  const handleVideoLoadedData = (index) => {
    setVideoLoading(prev => {
      const newSet = new Set(prev);
      newSet.delete(index);
      return newSet;
    });
  };

  const handleVideoEnded = (index) => {
    const newPlayedVideos = new Set(playedVideos);
    newPlayedVideos.add(index);
    setPlayedVideos(newPlayedVideos);

    // If user clicked a non-marketing video, stop auto-play
    if (userClickedNonMarketing) {
      const video = videoRefs.current[index];
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      setUserClickedNonMarketing(false); // Reset for next interaction
      return;
    }

    // Auto-continue to next video (for AI Marketing or auto-play mode)
    // Check if all videos have been played
    if (newPlayedVideos.size === teamMembers.length) {
      // setAllVideosPlayed(true);
      // Reset for next cycle
      setPlayedVideos(new Set());
      updateCarousel(0);
      return;
    }

    const nextIndex = (index + 1) % teamMembers.length;
    updateCarousel(nextIndex);

    setTimeout(() => {
      const nextVideo = videoRefs.current[nextIndex];
      if (nextVideo) {
        nextVideo.play();
      }
    }, 900);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') {
      updateCarousel(currentIndex - 1);
    } else if (e.key === 'ArrowRight') {
      updateCarousel(currentIndex + 1);
    }
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    const touchEnd = e.changedTouches[0].clientX;
    const diff = touchStart - touchEnd;

    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        updateCarousel(currentIndex + 1);
      } else {
        updateCarousel(currentIndex - 1);
      }
    }
  };

  const scrollToSection = (prefix) => {
    const firstSectionIndex = renderComponents.findIndex(
      (comp) => comp.id && comp.id.startsWith(prefix)
    );

    if (firstSectionIndex !== -1 && sectionRefs?.current[firstSectionIndex]) {
      const element = sectionRefs.current[firstSectionIndex];
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 95; // Scroll 100px above the target

      window.scrollTo({
        top: offsetPosition,
        // behavior: "smooth"
      });
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);

  // Scroll listener for sticky effect and section tracking
  useEffect(() => {
    const handleScroll = () => {
      if (carouselRef.current) {
        const rect = carouselRef.current.getBoundingClientRect();
        setIsSticky(rect.bottom <= 100);
      }

      // Track which section is in view based on ID prefix
      if (sectionRefs?.current && sectionRefs.current.length > 0) {
        const scrollPosition = window.scrollY + window.innerHeight / 2;

        for (let i = 0; i < sectionRefs.current.length; i++) {
          const section = sectionRefs.current[i];
          if (section) {
            const sectionTop = section.offsetTop;
            const sectionBottom = sectionTop + section.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              const sectionId = renderComponents[i]?.id;
              if (sectionId) {
                const stickyIndex = getStickyTeamMemberIndexFromId(sectionId);
                setStickyCurrentIndex(stickyIndex);
              }
              break;
            }
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [renderComponents]);

  useEffect(() => {
    if (!animationEnabled || isHovered || userInteracted) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % teamMembers.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [teamMembers.length, animationEnabled, isHovered, userInteracted]);

  return (
    <>
      {/* Main Carousel - Always visible with 5 items */}
      <div
        ref={carouselRef}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className='mb-[5vh]'
      >
        <div className="w-full h-[40vh] relative">
          <div
            className="w-full h-full flex justify-center items-center relative"
          >
            {teamMembers.map((member, index) => {
              const position = getCardPosition(index);

              return (
                <div
                  key={"asdasdasdwqeqwadasdsda" + index}
                  className={classNames(`absolute w-[26vh] h-[34vh] rounded overflow-hidden`, member.bg)}
                  style={{
                    ...getCardStyles(position),
                    cursor: 'pointer',
                    pointerEvents: position === 'hidden' ? 'none' : 'auto',
                  } as any}
                  onClick={() => {
                    // If this card is not in center, bring it to center and play video
                    if (index !== currentIndex) {
                      // Disable auto-rotation when user manually clicks
                      setUserInteracted(() => true);
                      setAnimationEnabled(() => false);

                      // Check if clicked card is NOT AI Marketing (index 0)
                      if (index !== 0) {
                        setUserClickedNonMarketing(() => true);
                      }

                      updateCarousel(index);

                      // Play video after carousel animation
                      setTimeout(() => {
                        const video = videoRefs.current[index];
                        if (video) {
                          video.currentTime = 0; // Start from beginning
                          video.play();
                        }
                      }, 900); // Match carousel animation duration
                    }
                  }}
                >
                  {member.prefix === PREFIX.ADMISSION_ASSURED_PREFIX ? (
                    <Img
                      src={member.image}
                      alt={member.role}
                      className='h-full'
                      imageClassName="w-full h-full object-cover"
                    />
                  ) : <>
                    {/* Skeleton Loader */}
                    {videoLoading.has(index) && (
                      <div role="status" className="absolute inset-0 flex items-center justify-center bg-gray-300 animate-pulse z-10">
                        <VideoIcon />
                        <span className="sr-only">Loading...</span>
                      </div>
                    )}
                    <video
                      ref={(el: any) => (videoRefs.current[index] = el) as any}
                      src={member.videoUrl}
                      className={classNames("w-full h-full transition-all duration-700", 'object-fit object-bottom')}
                      style={{
                        opacity: videoLoading.has(index) ? 0 : 1,
                        pointerEvents: index === currentIndex ? 'auto' : 'none'
                      }}
                      controls={false}
                      onLoadedData={() => handleVideoLoadedData(index)}
                      onPlay={() => handleVideoPlay(index)}
                      onEnded={() => handleVideoEnded(index)}
                      onClick={(e) => {
                        // Only handle video play/pause when card is in center
                        if (index === currentIndex && position === 'center') {
                          e.stopPropagation(); // Prevent parent div onClick
                          const video = videoRefs.current[index];
                          if (video) {
                            if (video.paused) {
                              video.play();
                              // If clicking non-marketing video, mark it
                              if (index !== 0) {
                                setUserClickedNonMarketing(true);
                              }
                            } else {
                              video.pause();
                            }
                          }
                        }
                      }}
                      playsInline
                    />
                  </>}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Sticky Header - Only shows when isSticky is true with 5 items + separate Webinar card */}
      {isSticky ? (
        <div className='fixed top-0 left-0 z-50 w-full'>
          <div className="bg-[#4949DE] text-[white] text-center py-2 px-4 text-xs sm:text-[10px]">
            Exclusive: First-year access worth ₹5,00,000 — Free for selected schools (1% per state)
          </div>
          <div className={classNames("bg-[white] shadow-md py-3 w-full flex justify-between md:justify-center items-center px-4", isWebinar ? "md:py-6" : "md:py-12")}>
            {/* Logo on the left */}
            <button type='button' onClick={scrollUp} className="flex items-center md:hidden">
              <Img src="images/newRedLogo.svg" alt="Logo" className='w-32 md:w-40' enableShimmer={false} />
            </button>

            {/* Carousel in the center */}
            <div
              ref={infoSectionRef}
              className={classNames("flex flex-1 justify-center items-center transition-all duration-300", isWebinar ? "md:hidden" : "")}
            >
              {stickyHeaderItems?.map((member: any, index) => {
                const position = getStickyCardPosition(index);
                const isActive = stickyCurrentIndex === index;

                return (
                  <div
                    key={"sticky-card-" + index}
                    className={classNames(
                      "absolute flex items-center p-2 gap-2 rounded-xl cursor-pointer transition-all duration-300",
                      "bg-[#F4F4F4]"
                    )}
                    style={{
                      ...getCardSection(position, true),
                      ...(isActive && {
                        border: `3px solid ${member.glowColor}`,
                        boxShadow: `0 0 20px ${member.glowColor}, 0 0 40px ${member.glowColor}80`,
                        backgroundColor: 'white'
                      })
                    } as any}
                    onClick={() => {
                      setStickyCurrentIndex(index);
                      scrollToSection(member.prefix);
                    }}
                  >
                    <div className={classNames("rounded flex items-center justify-center p-2", member.bg)}>
                      {member?.icon}
                    </div>

                    <div className="flex flex-col">
                      <h3 className={classNames("text-[2vh] font-semibold text-gray-900", member?.titleClass)}>{member?.role}</h3>
                      <p className="text-[1.7vh] text-gray-700">{member?.des}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Webinar card on the right */}
            <div
              className={classNames(
                "flex items-center p-2 gap-2 rounded-xl cursor-pointer transition-all duration-300",
                isWebinar ? "bg-[white]" : "bg-[#F4F4F4] hover:bg-[white] hover:shadow-lg",
                isWebinar ? "" : "md:hidden"
              )}
              style={{
                ...(isWebinar && {
                  border: `3px solid ${webinarCard.glowColor}`,
                  boxShadow: `0 0 20px ${webinarCard.glowColor}, 0 0 40px ${webinarCard.glowColor}80`,
                })
              } as any}
              onClick={() => scrollToSection(webinarCard.prefix)}
            >
              <div className={classNames("rounded flex items-center justify-center p-2", webinarCard.bg)}>
                {webinarCard?.icon}
              </div>

              <div className="flex flex-col">
                <h3 className="text-[2vh] font-semibold text-gray-900">{webinarCard?.role}</h3>
                <p className="text-[1.7vh] text-gray-700">{webinarCard?.des}</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          ref={infoSectionRef}
          className={classNames(
            "w-full flex justify-center items-center transition-all duration-300",
            isSticky
              ? "fixed top-0 left-0 z-50 bg-[white] shadow-md py-10"
              : "relative mt-6"
          )}
          style={{ transformStyle: isSticky ? 'none' : 'preserve-3d' } as any}
        >
          {teamMembers?.map((member, index) => (
            <div
              key={"ajbdakjsdbasdasnmdbasda" + index}
              className={classNames("absolute flex items-center p-3 gap-2 bg-[#F4F4F4] rounded-xl")}
              style={{
                ...getCardSection(getCardPosition(index)),
              } as any}
            >
              <div className={classNames("rounded flex items-center justify-center p-2", member.bg)}>
                {member?.icon}
              </div>

              <div className="flex flex-col">
                <h3 className="text-[2vh] font-semibold text-gray-900">{member?.role}</h3>
                <p className="text-[1.7vh] text-gray-700">{member?.des}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CardsCarousel;

const VideoIcon = () => {
  return <svg className="w-11 h-11 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinejoin="round" strokeWidth="2" d="M10 3v4a1 1 0 0 1-1 1H5m14-4v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1ZM9 12h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1Zm5.697 2.395v-.733l1.269-1.219v2.984l-1.268-1.032Z" />
  </svg>
}